<header>
  <div>
    <app-accessibility-bar></app-accessibility-bar>
    <nav class="navbar navbar-expand-lg bg-white">
      <div class="container d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <a class="navbar-brand" href="#">
            <img
              class="laplogo"
              src="/assets/images/mines.svg"
              alt="nationalemblem"
            />
            <img
              class="phnlogo"
              src="/assets/images/nationalemblem.svg"
              alt="nationalemblem"
            />
          </a>
          <a class="navbar-brand" href="/"> <div class="divider"></div></a>
          <a class="navbar-brand" href="/">
            <img src="/assets/images/jnardc.svg" alt="jnardc Logo" />
          </a>
          <a class="navbar-brand" href="/">
            <img
              class="laplogo"
              src="/assets/images/Recyclinglogo.svg"
              alt="Government Logo"
            />
            <img
              class="phnlogo"
              src="/assets/images/reclogo.svg"
              alt="Government Logo"
            />
          </a>
        </div>
        <div
          class="d-flex justify-content-center align-items-center position-relative ms-auto"
        >
          <button
            class="navbar-toggler position-static ms-1"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div
            class="collapse navbar-collapse ms-2"
            id="navbarSupportedContent"
          >
            <ul class="navbar-nav d-flex gap-2">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  About Us
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" href="/about-us"
                      >Recycling Promotion Division</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" href="/secretary-message"
                      >Secretary's Message</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item block d-flex justify-content-between align-items-center"
                      href="https://mines.gov.in/webportal/home"
                      target="_blank"
                      >Ministry of Mines
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                      >
                        <path
                          d="M1.07692 10L0 8.92308L7.38462 1.53846H0.769231V0H10V9.23077H8.46154V2.61538L1.07692 10Z"
                          fill="#1C1B1F"
                        /></svg
                    ></a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="/vision-mission"
                      >Our Vision</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" href="/whoswho">Who's Who</a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/']" [fragment]="'pillars'">
                  Key Pillars
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/']"
                  [fragment]="'upcoming'"
                >
                  Events
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/']"
                  [fragment]="'getrating'"
                >
                  Get Rating
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/']" [fragment]="'gallery'">
                  Gallery
                </a>
              </li>
            </ul>
          </div>

          <!-- <div class="search-container">
            <form
              class="d-flex search-form"
              role="search"
              [ngClass]="{ active: isSearchActive }"
            >
              <div class="input-wrapper">
                <input
                  class="form-control search-input"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
                <button
                  class="btn search-btn mx-2"
                  type="button"
                  (click)="toggleSearch()"
                >
                  <svg
                    *ngIf="!isSearchActive"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.26 13.27L20.99 19L19.5 20.49L13.77 14.76C12.7 15.53 11.41 16 10 16C6.41 16 3.5 13.09 3.5 9.5C3.5 5.91 6.41 3 10 3C13.59 3 16.5 5.91 16.5 9.5C16.5 10.91 16.03 12.2 15.26 13.27ZM10 5C7.51 5 5.5 7.01 5.5 9.5C5.5 11.99 7.51 14 10 14C12.49 14 14.5 11.99 14.5 9.5C14.5 7.01 12.49 5 10 5Z"
                      fill="#1E5126"
                    />
                  </svg>
                  <svg
                    *ngIf="isSearchActive"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6 6L18 18M6 18L18 6"
                      stroke="#1E5126"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </form>
          </div> -->

          <button class="greenbtn ms-lg-3" [routerLink]="['/auth']">
            Stakeholders Portal
          </button>
        </div>
      </div>
    </nav>
  </div>
</header>
